import { render, staticRenderFns } from "./priceCell.vue?vue&type=template&id=9f0a5bc4&scoped=true"
import script from "./priceCell.vue?vue&type=script&lang=js"
export * from "./priceCell.vue?vue&type=script&lang=js"
import style0 from "./priceCell.vue?vue&type=style&index=0&id=9f0a5bc4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0a5bc4",
  null
  
)

export default component.exports